

export const getToken = () => {
  var token = localStorage.getItem("token");
  if (token === undefined || token === null) {
    //localStorage.setItem("token", token);
    return ""
  }
  return token;
}

export const setToken = (token) => {
  localStorage.setItem("token", token);
}

export const setLogin = () => {
  localStorage.setItem("isLogin", true);
}

export const isLogin = () => {
  var isLogin = localStorage.getItem("isLogin");
  if (isLogin === undefined || isLogin === null) {
    //localStorage.setItem("token", token);
    return false;
  }
  return isLogin;
}

export const logout = () => {
  localStorage.setItem("token", "");
  localStorage.setItem("isLogin", false);
  localStorage.setItem("menuItems", []);
  localStorage.setItem("menuList", []);
  localStorage.setItem("resume2token", "");
  var texIdNumber = getTexIdNumber()
  localStorage.clear();
  setTexIdNumber(texIdNumber)
}

export const getUserInfo = () => {
  var userInfo = localStorage.getItem("userInfo");
  if (userInfo === undefined || userInfo === null) {
    //localStorage.setItem("token", token);
    return {}
  }
  var json = JSON.parse(userInfo);
  return json;
}

export const getUserInfoCompanyId = () => {
  var userInfo = getUserInfo();
  if (userInfo === undefined || userInfo === null || userInfo.companyId === undefined) {
    //localStorage.setItem("token", token);
    return ""
  }
  return userInfo.companyId;
}

export const setUserInfo = (userInfo) => {
  var json = JSON.stringify(userInfo);
  localStorage.setItem("userInfo", json);
}

export const setTexIdNumber = (texIdNumber) => {
  localStorage.setItem("texIdNumber", texIdNumber);
}

export const getTexIdNumber = () => {
  var texIdNumber = localStorage.getItem("texIdNumber");
  if (texIdNumber === null || texIdNumber === undefined) {
    texIdNumber = ""
  }
  return texIdNumber
}
/*
//選單樹狀結構
export const getMenuItems = () => {
  var menu = localStorage.getItem("menuItems");
  //console.log("getMenuItems")
  if(menu === undefined || menu === "undefined" || menu === null || menu === ""){
    return [];
  }else{
    //console.log(menu)
    var json = JSON.parse(menu);
    return json;
  }
}

export const setMenuItems = (menu) => {  
  var json = JSON.stringify(menu);
  //console.log(json);
  localStorage.setItem("menuItems", json);
}

//選單列表
export const getMenuList = () => {
  var menu = localStorage.getItem("menuList");
  if(menu === undefined || menu === null || menu === ""){
    return [];
  }else{
    var json = JSON.parse(menu);
    return json;
  }
}

export const setMenuList = (menu) => {
  var json = JSON.stringify(menu);
  //console.log(json);
  localStorage.setItem("menuList", json);
}
*/

//頁面列表
export const getPageList = () => {
  var page = localStorage.getItem("pageList");
  if (page === undefined || page === null || page === "") {
    return [];
  } else {
    var json = JSON.parse(page);
    return json;
  }
}

export const setPageList = (page) => {
  var json = JSON.stringify(page);
  localStorage.setItem("pageList", json);
}

export const setResume2Token = (resumeId, tokenId) => {
  setVal2Token("resume2token", resumeId, tokenId)
  // var rt = {resumeId, tokenId}
  // var json = JSON.stringify(rt);
  // localStorage.setItem("resume2token", json);
}

export const getResume2Token = (tokenId) => {
  return getval2Token("resume2token", tokenId)
  // var json = localStorage.getItem("resume2token");
  // if(json === undefined || json === null || json === ""){
  //   return ""
  // }else{
  //   var rt = JSON.parse(json);
  //   if(rt.tokenId !== tokenId){
  //     return ""
  //   }else{
  //     return rt.resumeId
  //   }
  // }

}

export const setVal2Token = (key, val, tokenId) => {
  // console.log(key)
  // console.log(val)
  // console.log(tokenId)
  var obj = getVal2TokenObj(key)
  obj[tokenId] = val
  var json = JSON.stringify(obj);
  // console.log(obj)
  localStorage.setItem(key, json);
}

export const getVal2TokenObj = (key) => {
  var json = localStorage.getItem(key);
  // console.log(json)
  if (json === undefined || json === null || json === "") {
    return {}
  } else {
    var arr = JSON.parse(json);
    return arr
  }
}
export const getval2Token = (key, tokenId) => {
  var arr = getVal2TokenObj(key)
  var item = arr[tokenId]
  if (item === undefined) {
    return ""
  }else {
    return item
  }
  // return item
  // var json = localStorage.getItem(key);
  // if (json === undefined || json === null || json === "") {
  //   return ""
  // } else {
  //   var rt = JSON.parse(json);
  //   if (rt.tokenId !== tokenId) {
  //     return ""
  //   } else {
  //     return rt.id
  //   }
  // }
}

/*

  // 储存一个session
localStorage.setItem("key", "value");

// 获取一个session
var value = localStorage.getItem("key");

// 删除一个session
localStorage.removeItem("key");

// 清除所有session
localStorage.clear();

// 遍历session
for(var i=0; i<localStorage.length; i++){
  var key = storage.key(i);
  var value = storage.getItem(key);
  console.log(key + "=" + value);
}
*/